var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _path3, _path4, _rect8, _rect9, _rect10, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrepaidRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 100,
    viewBox: "0 0 120 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.6185,
    y: 42.9341,
    width: 45,
    height: 33,
    rx: 5.5,
    transform: "rotate(-10.3347 66.6185 42.9341)",
    fill: "#A2D4FF",
    stroke: "white",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 69.4395,
    y: 50.043,
    width: 42,
    height: 5,
    transform: "rotate(-10.3347 69.4395 50.043)",
    fill: "#459CFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 75.9727,
    y: 58,
    width: 9,
    height: 9,
    rx: 1,
    transform: "rotate(-10.3347 75.9727 58)",
    fill: "#459CFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 90.8223,
    y: 61.3906,
    width: 3,
    height: 3,
    rx: 1.5,
    transform: "rotate(-10.3347 90.8223 61.3906)",
    fill: "#459CFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7412,
    y: 60.4941,
    width: 3,
    height: 3,
    rx: 1.5,
    transform: "rotate(-10.3347 95.7412 60.4941)",
    fill: "#459CFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 100.66,
    y: 59.5977,
    width: 3,
    height: 3,
    rx: 1.5,
    transform: "rotate(-10.3347 100.66 59.5977)",
    fill: "#459CFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 105.579,
    y: 58.7012,
    width: 3,
    height: 3,
    rx: 1.5,
    transform: "rotate(-10.3347 105.579 58.7012)",
    fill: "#459CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5723 19.3863C77.5675 19.5997 79.0124 21.3906 78.799 23.3859L72.4754 82.5106C72.2408 84.7042 69.3153 85.2812 68.2655 83.341L66.8544 80.7318C66.643 80.3413 66.1054 80.2837 65.8163 80.6208L64.3408 82.3418C62.6819 84.2758 59.5996 83.9462 58.3874 81.7051L57.3092 79.7109C57.0979 79.3203 56.5603 79.2629 56.2712 79.5999L54.7956 81.3209C53.1367 83.2552 50.0534 82.9256 48.8413 80.6841L47.763 78.6899C47.5517 78.2996 47.0151 78.2422 46.726 78.579L45.2504 80.3C43.5916 82.2344 40.5084 81.9046 39.2961 79.6632L38.2179 77.669C38.0065 77.2785 37.469 77.2209 37.1799 77.558L35.7043 79.279C34.0455 81.2131 30.9632 80.8834 29.7509 78.6423L28.6727 76.6481C28.4615 76.2575 27.9239 76.2002 27.6347 76.5371L25.7036 78.7889C24.2673 80.4632 21.53 79.2805 21.7646 77.0869L28.0882 17.9622C28.3016 15.9669 30.0926 14.522 32.0878 14.7354L75.5723 19.3863Z",
    fill: "#EDEDED",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2524 46.0792C49.6666 46.0165 49.2426 45.4909 49.3052 44.9051L49.3679 44.3192C48.4061 44.1863 47.4705 43.9662 46.561 43.6589C46.2209 43.544 45.9013 43.4239 45.6023 43.2987C44.828 42.9744 44.577 42.0504 44.9682 41.3077C45.3739 40.5375 46.3196 40.2409 47.1311 40.556C47.2877 40.6168 47.446 40.6756 47.606 40.7325C48.2873 40.9704 48.9841 41.1424 49.6963 41.2486L50.039 38.0445C49.4409 37.8155 48.8368 37.5633 48.2268 37.2881C47.6168 37.0128 47.0631 36.6835 46.5656 36.3002C46.0863 35.9038 45.7073 35.4357 45.4285 34.8958C45.1663 34.3576 45.0749 33.7177 45.1542 32.976C45.2843 31.7596 45.8656 30.8091 46.898 30.1243C47.947 29.4413 49.3153 29.0775 51.0028 29.033L51.1202 27.9353C51.1829 27.3495 51.7085 26.9254 52.2943 26.9881C52.88 27.0507 53.3041 27.5764 53.2414 28.1621L53.1359 29.1486C54.0161 29.2577 54.861 29.4606 55.6707 29.7573C55.9583 29.8572 56.2252 29.9624 56.4715 30.073C57.1649 30.3843 57.3491 31.223 56.9922 31.894C56.5857 32.6587 55.6351 32.9296 54.8318 32.6061C54.7361 32.5676 54.6404 32.5305 54.5449 32.495C53.9951 32.2862 53.4215 32.1423 52.8242 32.0634L52.4815 35.2675C53.063 35.4948 53.6496 35.7525 54.2414 36.0409C54.8332 36.3292 55.3687 36.6716 55.8479 37.0679C56.3288 37.4494 56.7003 37.9093 56.9625 38.4474C57.2262 38.9707 57.32 39.5884 57.2438 40.3004C57.1026 41.6206 56.5234 42.6314 55.506 43.3328C54.5053 44.036 53.1703 44.4033 51.501 44.4348L51.4264 45.132C51.3638 45.7178 50.8382 46.1418 50.2524 46.0792ZM49.2351 33.0524C49.205 33.3342 49.2961 33.584 49.5084 33.8018C49.7389 34.0065 50.0458 34.2043 50.4293 34.3954L50.6839 32.0146C49.7799 32.1279 49.297 32.4739 49.2351 33.0524ZM51.8342 41.3197C52.6914 41.1714 53.1526 40.7931 53.2176 40.1849C53.2462 39.9179 53.1535 39.6829 52.9396 39.48C52.7424 39.2789 52.4604 39.0837 52.0936 38.8944L51.8342 41.3197Z",
    fill: "#929292"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7295 52.248L61.0631 54.7437",
    stroke: "#929292",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.709 61.7949L60.0426 64.2905",
    stroke: "#929292",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 68.4199,
    y: 43.9297,
    width: 41.9984,
    height: 30.3322,
    rx: 3.94202,
    transform: "rotate(-10.33 68.4199 43.9297)",
    fill: "#FF4400"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 70.9316,
    y: 57.6992,
    width: 41.9984,
    height: 4.66649,
    transform: "rotate(-10.33 70.9316 57.6992)",
    fill: "#FFCEC0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 91.374,
    y: 39.7461,
    width: 4.66649,
    height: 30.3322,
    transform: "rotate(-10.33 91.374 39.7461)",
    fill: "#FFCEC0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6389 54.0397C97.7248 54.4556 97.9834 55.8745 97.1141 56.6468L90.8447 62.2167C89.9408 63.0197 88.5063 62.5251 88.2895 61.3355L86.7275 52.766C86.5107 51.5765 87.6784 50.6075 88.8076 51.04L96.6389 54.0397Z",
    fill: "#FFCEC0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0802 54.1367C95.2109 54.909 95.4695 56.3279 96.5554 56.7438L104.387 59.7435C105.516 60.176 106.684 59.207 106.467 58.0175L104.905 49.448C104.688 48.2584 103.253 47.7638 102.35 48.5668L96.0802 54.1367Z",
    fill: "#FFCEC0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3655 9.44177C94.5834 8.85275 95.4166 8.85274 95.6345 9.44176L96.3103 11.2682C96.7255 12.39 97.61 13.2745 98.7318 13.6897L100.558 14.3655C101.147 14.5834 101.147 15.4166 100.558 15.6345L98.7318 16.3103C97.61 16.7255 96.7255 17.61 96.3103 18.7318L95.6345 20.5582C95.4166 21.1473 94.5834 21.1473 94.3655 20.5582L93.6897 18.7318C93.2745 17.61 92.39 16.7255 91.2682 16.3103L89.4418 15.6345C88.8527 15.4166 88.8527 14.5834 89.4418 14.3655L91.2682 13.6897C92.39 13.2745 93.2745 12.39 93.6897 11.2682L94.3655 9.44177Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.365 82.4418C101.583 81.8527 102.417 81.8527 102.635 82.4418L103.31 84.2682C103.725 85.39 104.61 86.2745 105.732 86.6897L107.558 87.3655C108.147 87.5834 108.147 88.4166 107.558 88.6345L105.732 89.3103C104.61 89.7255 103.725 90.61 103.31 91.7318L102.635 93.5582C102.417 94.1473 101.583 94.1473 101.365 93.5582L100.69 91.7318C100.275 90.61 99.39 89.7255 98.2682 89.3103L96.4418 88.6345C95.8527 88.4166 95.8527 87.5834 96.4418 87.3655L98.2682 86.6897C99.39 86.2745 100.275 85.39 100.69 84.2682L101.365 82.4418Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36549 55.4418C9.58345 54.8527 10.4166 54.8527 10.6345 55.4418L11.3103 57.2682C11.7255 58.39 12.61 59.2745 13.7318 59.6897L15.5582 60.3655C16.1473 60.5834 16.1473 61.4166 15.5582 61.6345L13.7318 62.3103C12.61 62.7255 11.7255 63.61 11.3103 64.7318L10.6345 66.5582C10.4166 67.1473 9.58345 67.1473 9.36549 66.5582L8.68966 64.7318C8.27454 63.61 7.39003 62.7255 6.26818 62.3103L4.44177 61.6345C3.85275 61.4166 3.85274 60.5834 4.44176 60.3655L6.26818 59.6897C7.39003 59.2745 8.27454 58.39 8.68966 57.2682L9.36549 55.4418Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepaidRecord);
export default __webpack_public_path__ + "static/media/prepaid-record.4dbbb64881e7e535cf8c67a4d31f4142.svg";
export { ForwardRef as ReactComponent };